import { useState, useEffect } from "react";

const breakpoints = [{ name: "mobile", width: 900 }];

export default () => {
  const [media, setMedia] = useState();

  useEffect(() => {
    const onResize = () => {
      const targetMedia = breakpoints.reduce(
        (acc, cur) => (window.innerWidth < cur.width ? cur.name : acc),
        "desktop"
      );
      if (targetMedia !== media) setMedia(targetMedia);
    };

    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, [media]);

  return media;
};
